import EntityListTemplate from '../../templates/EntityListTemplate'

const HardwareListPage = () => {
  return (
    <EntityListTemplate
      entityName="hardware"
      title="Hardware List"
      defaultSort={[]}
      defaultFilters={{ items: [] }}
      fetchWithMeta={true}
    />
  )
}

export default HardwareListPage
